export { AppPermission as P_ } from './permissions.constants';
